export default __webpack_public_path__ + "static/media/8.8d4d6d14.png";